/* eslint-disable */
//This page is mostly linted, except for two strange Prettier errors.
//Uncomment the eslint-disable to see
import React, { FC, useContext, useState, useEffect } from 'react';
import ExistingList from 'Components/SmartList/ExistingList';
import UserDetailsContext from 'Context/userDetailsContext';
import {
  leadListGql,
  updateListGql,
  updateIndividualListGql,
  duplicateListGql,
  appendUsersToListGql,
  deleteListGql,
  createListGql,
} from './gqlQuery';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery, useMutation } from '@apollo/react-hooks';
import { useFocusManager } from '@react-aria/focus';
import { toastMessage } from 'Containers/Toast/actions';
import { useDispatch } from 'react-redux';
import { Loading } from 'Components/Loading';
import { FormattedDate } from 'Utils/formattedDate';
//@ts-ignore
import commaNumber from 'comma-number';
import { numberWithCommas } from 'Utils/numberWithCommas';
import { setNewListValue } from 'Containers/Filter/ListMembership/actions/listMembership.actions';
import withErrorBoundary from 'HOC/ErrorBoundary';

interface Props {
  fromListId?: String;
  checkedItems?: any;
  userIds: any[];
  userInfo?: any[];
  closeModal: () => void;
  searchText?: string;
}

const DEFAULT_SORTING_COLUMN = 'lastModified';
const DEFAULT_SORTING_DIRECTION = 'desc';

// Need to have this info
const mapColumnsToKeys = (column: string, direction?: string) => {
  switch (column) {
    case 'name':
      return `name:${direction}`;
    case 'leads':
      return `count:${direction}`;
    case 'lastModified':
      return `updatedAt:${direction}`;
    default:
      return '';
  }
};

const ExistingListContainer: FC<Props> = ({
  fromListId,
  checkedItems,
  userIds,
  closeModal,
  searchText,
}: Props) => {
  const Dispatch = useDispatch();
  const userDetails = useContext(UserDetailsContext);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedList, setSelectedList] = useState('');

  let profiles = [];

  checkedItems.forEach((item: string, idx: number) =>
    profiles.push({ userkey: item, id: userIds[idx] })
  );

  const [sortColumnObject, setSortColumnObject] = useState({
    column: DEFAULT_SORTING_COLUMN,
    direction: DEFAULT_SORTING_DIRECTION,
  });

  const { loading: listLoading, data: listData, refetch } = useQuery(
    leadListGql,
    {
      notifyOnNetworkStatusChange: true,
      variables: {
        inst_id: userDetails.instId,
        account_id: userDetails.accountId,
        sort: mapColumnsToKeys(
          sortColumnObject.column,
          sortColumnObject.direction
        ),
        size: 5,
        page: page,
        search: 'name::' + searchTerm,
        myListsOnly: true,
      },
      fetchPolicy: 'cache-and-network',
      onCompleted: (data: any) => {
        setSelectedList(
          (data &&
            data.paginatedList &&
            data.paginatedList['list'].length &&
            data.paginatedList['list'][0]) ||
            ''
        );
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [searchTerm]);

  const [
    updateList,
    { loading: updateLoading, data: updateData },
  ] = useMutation(updateListGql);

  const [
    createNewList,
    { loading: createListLoading, data: createListData },
  ] = useMutation(createListGql);

  const [
    updateIndividualList,
    { loading: updateIndividualLoading, data: updateIndividualData },
  ] = useMutation(updateIndividualListGql);

  const [duplicateList, { loading: dupLoading, data: dupData }] = useMutation(
    deleteListGql
  );

  const [deleteList] = useMutation(duplicateListGql);

  if (listData) {
    listData.paginatedList.list.forEach((item: any) => {
      item.lastModified = FormattedDate(item.lastModified); //eslint-disable-line
    });
  }

  const [
    appendUsers,
    { loading: appendUsersLoading, data: appendUsersData },
  ] = useMutation(appendUsersToListGql);

  const columns = ['name', 'leads', 'lastModified'];
  const allColumns = ['name', 'leads', 'lastModified'];

  async function onSaveHandler(e: any) {
    if (!e.overwrite) {
      if (checkedItems.length === 0) {
        if (fromListId !== e.selection.userKeyConsolidated) {
          updateIndividualList({
            variables: {
              inst_id: userDetails.instId,
              account_id: userDetails.accountId,
              copy_from_id: fromListId,
              copy_to_id: e.selection.userKeyConsolidated,
              audiencesSearch: searchText,
            },
          });
        }
      } else {
        appendUsers({
          variables: {
            inst_id: userDetails.instId,
            account_id: userDetails.accountId,
            id: e.selection.userKeyConsolidated,
            profiles: profiles,
          },
        });
      }

      updateList({
        variables: {
          inst_id: userDetails.instId,
          account_id: userDetails.accountId,
          id: e.selection.userKeyConsolidated,
          name: e.renameValue.length > 0 ? e.renameValue : '',
        },
      });
    } else {
      if (checkedItems.length === 0) {
        if (fromListId !== e.selection.userKeyConsolidated) {
          deleteList({
            variables: {
              inst_id: userDetails.instId,
              account_id: userDetails.accountId,
              id: e.selection.userKeyConsolidated,
            },
          }).then(() => {
            duplicateList({
              variables: {
                inst_id: userDetails.instId,
                account_id: userDetails.accountId,
                name:
                  e.renameValue.length > 0 ? e.renameValue : e.selection.name,
                id: fromListId,
                audiencesSearch: searchText,
              },
            });
          });
        } else {
          Dispatch(
            toastMessage({
              message: `No inquiries to overwrite`,
              position: 'bottom',
            })
          );
          closeModal();
        }
      } else {
        deleteList({
          variables: {
            inst_id: userDetails.instId,
            account_id: userDetails.accountId,
            id: e.selection.userKeyConsolidated,
          },
        }).then(() => {
          createNewList({
            variables: {
              inst_id: userDetails.instId,
              account_id: userDetails.accountId,
              name: e.renameValue.length > 0 ? e.renameValue : e.selection.name,
              listType: 'custom',
              createUser: userDetails.accountId,
              audiencesSearch: searchText,
            },
          });
        });
      }
    }
    setNewListValue(Dispatch, true);
  }

  useEffect(() => {
    if (appendUsersData && updateData) {
      Dispatch(
        toastMessage({
          message: `Inquiries added to ${appendUsersData.listAudienceAppendIds.data.name}`,
          position: 'bottom',
        })
      );
      closeModal();
    }
    if (updateData) {
      Dispatch(
        toastMessage({
          message: `${updateData.listUpdate.data.name} updated with inquiries`,
          position: 'bottom',
        })
      );
      closeModal();
    }
    if (appendUsersData) {
      Dispatch(
        toastMessage({
          message: `Inquiries added to ${appendUsersData.listAudienceAppendIds.data.name}`,
          position: 'bottom',
        })
      );
      closeModal();
    }
  }, [appendUsersData, updateData]);

  useEffect(() => {
    if (dupData) {
      if (checkedItems.length <= 0) {
        let count = commaNumber(dupData.listDuplicate.data.count);
        Dispatch(
          toastMessage({
            message: `Added ${numberWithCommas(count)} Inquiries to ${
              dupData.listDuplicate.data.name
            }`,
            position: 'bottom',
          })
        );
        closeModal();
      }
    }
  }, [dupData]);

  useEffect(() => {
    if (createListData) {
      if (checkedItems.length > 0) {
        appendUsers({
          variables: {
            inst_id: userDetails.instId,
            account_id: userDetails.accountId,
            id: createListData.listCreate.data.id,
            profiles: profiles,
          },
        });
      }
    }
  }, [createListData]);

  // This fixes focus getting out of Modal Dialog when user switches between "Existing List" and "Create New",
  // while using screen reader (ChromeVox). It doesn't happen if we don't use screen reader.
  const focusManager = useFocusManager();
  useEffect(() => {
    if (focusManager) {
      focusManager.focusFirst();
    }
  }, [focusManager]);

  if (listData && listData.paginatedList) {
    return (
      <ExistingList
        disabled={
          createListData ||
          updateData ||
          updateIndividualData ||
          appendUsersData ||
          dupData ||
          createListLoading ||
          updateLoading ||
          updateIndividualLoading ||
          appendUsersLoading ||
          dupLoading
        }
        loading={listLoading}
        sort={{
          activeColumn: {
            name: sortColumnObject.column,
            direction: sortColumnObject.direction,
          },
          events: {
            onClickSortHandler: (column: string) => {
              let newSortingDirection;
              if (column === sortColumnObject.column) {
                newSortingDirection =
                  sortColumnObject.direction === 'desc' ? 'asc' : 'desc';
              } else {
                newSortingDirection = 'desc';
              }
              setSortColumnObject({
                column: column,
                direction: newSortingDirection,
              });
            },
          },
        }}
        listData={listData.paginatedList}
        columns={columns}
        allColumns={allColumns}
        closeModal={closeModal}
        page={listData.paginatedList.page}
        recordsPerPage={5} //eslint-disable-line
        pagingTotalRecords={listData.paginatedList.totalRecords}
        pagingPrevPage={() =>
          //eslint-disable-line
          setPage(page <= 1 ? listData.paginatedList.totalPages : page - 1)
        }
        pagingNextPage={() =>
          setPage(page >= listData.paginatedList.totalPages ? 1 : page + 1)
        }
        onCreate={e => onSaveHandler(e)}
        selectedList={selectedList}
        setSelectedList={(val: any) => setSelectedList(val)}
        onSearch={(e: any) => {
          setPage(1);
          setSearchTerm(e.target.value.length >= 3 ? e.target.value : '');
        }}
      ></ExistingList>
    );
  } else {
    return <Loading />;
  }
};
ExistingListContainer.defaultProps = {
  fromListId: '',
  checkedItems: [],
  searchText: '',
};
export default withErrorBoundary(ExistingListContainer);
